exports.components = {
  "component---src-pages-vision-404-tsx": () => import("./../../../src/pages-vision/404.tsx" /* webpackChunkName: "component---src-pages-vision-404-tsx" */),
  "component---src-pages-vision-demo-thanks-tsx": () => import("./../../../src/pages-vision/demo-thanks.tsx" /* webpackChunkName: "component---src-pages-vision-demo-thanks-tsx" */),
  "component---src-pages-vision-demo-tsx": () => import("./../../../src/pages-vision/demo.tsx" /* webpackChunkName: "component---src-pages-vision-demo-tsx" */),
  "component---src-pages-vision-index-tsx": () => import("./../../../src/pages-vision/index.tsx" /* webpackChunkName: "component---src-pages-vision-index-tsx" */)
}

